module.exports = __webpack_public_path__ + "assets/img/function6.725e274a.png";